import { render, staticRenderFns } from "./PriceForm.vue?vue&type=template&id=34b2d12e&scoped=true"
import script from "./PriceForm.vue?vue&type=script&lang=js"
export * from "./PriceForm.vue?vue&type=script&lang=js"
import style0 from "./PriceForm.vue?vue&type=style&index=0&id=34b2d12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2d12e",
  null
  
)

export default component.exports